'use strict';

//
import './filter.css'

//
import React from 'react';
import classnames from 'classnames';

//
import Component from '../core/component';
import Enhance from '../core/enhance';

//
import Animate from '../common/animate';
import Iscroll from '../common/iscroll'

//
import {findEventProps} from '../libs/tools';

/**
 * 筛选器
 * items={[
 *     title: '一级标题',
 *     value：0，
 *     name:"",
 *     items:[
 *          title: '二级标题',
 *          value：0,
 *          name:"",
 *          items:[
 *              title:'三级标题',
 *              value:0,
 *              name:"",
 *          ]
 *     ]
 * ]}
 * onChange={value=>{}}
 */
class Filter extends Component {
    state = {
        selected: -1,
        selectedItem: {}
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="w-filter">
                <div className="buttons-tab w-filter-tabs">{this.getTabsView()}</div>
                <div className="tabs w-filter-pages">{this.getPageView()}</div>
                <Animate className="w-filter-overlay fast"
                         name={this.state.selected > -1 ? 'fadeIn' : 'fadeOut'}
                         display={this.state.selected > -1}
                         onClick={this._handlerHide}
                ></Animate>
            </div>
        );
    }

    /**
     *
     * @returns {*}
     * @private
     */
    getTabsView() {
        return this.props.items && this.props.items.map((function (item, key) {
                return <a key={key}
                          className={classnames("tab-link button c-filter-tab", {active: key == this.state.selected})}
                          onClick={this._handlerTitleClick.bind(this, key)}>
                    {item.title}
                </a>
            }).bind(this))
    }

    /**
     *
     * @returns {*}
     * @private
     */
    getPageView() {
        return this.props.items && this.props.items.map((function (item, key) {
                return (
                    <Animate
                        className="c-filter-page fast"
                        key={key}
                        name={key == this.state.selected ? "fadeInDown" : "fadeOutUp"}
                        display={key == this.state.selected}
                    >
                        <Iscroll>{this.getItemView(item.items, key)}</Iscroll>
                    </Animate>
                )
            }).bind(this))
    }

    /**
     *
     * @param items
     * @param index
     * @returns {*}
     */
    getItemView(items, index) {
        return items && items.map((function (item, key) {
                return (
                    <div key={key} className={classnames('c-filter-page-item',{'active':this.state.selectedItem[item.name]==item.value})}
                         onClick={this._handlerItemClick.bind(this,item)}
                    ><span>{item.title}</span></div>
                );
            }).bind(this));
    }

    /**
     *
     * @param selected
     * @param e
     * @private
     */
    _handlerTitleClick(selected, e) {
        this.setState({selected});
    }


    /**
     *
     * @private
     */
    _handlerHide() {
        this.setState({selected: -1});
    }

    /**
     *
     * @param item
     * @param index
     * @private
     */
    _handlerItemClick(item) {
        var {selectedItem} = this.state;
        selectedItem[item.name] = item.value;
        this.props.onSelected && this.props.onSelected(selectedItem);
        this.setState({selectedItem});
    }


}

export default Enhance(Filter, {}, 'Filter');